const DEFAULT_ERROR = 'Une erreur imprévue est survenue, veuillez réessayer.';

export default function getErrorsFromResponse ({ response={ }, error })
{
	error = error || DEFAULT_ERROR;

	let update =
	{
		loading: false,

		info: undefined,

		error: !response?.warning
		? (response?.error || error)
		: undefined,

		warning: response?.warning,

		error_type: response?.error_type || undefined,

		status_messages: response?.fields || { }
	};

	return update;
}